import { reportPerformancePaintTimings, reportFirstInputDelay, reportFirstConsistentlyInteractive } from '../helpers/performance';
import { agent } from '../helpers/utils';

export default async function(customMetrics) {
    const defaultMetrics = [reportPerformancePaintTimings(), reportFirstInputDelay(), reportFirstConsistentlyInteractive()];
    const allMetricsPromises = customMetrics && customMetrics.length > 0 ? defaultMetrics.concat(customMetrics) : defaultMetrics;

    return await Promise.all(allMetricsPromises)
        .then(metrics => {
            const timings = metrics.reduce((acc, metric) => {
                if (metric) {
                    acc = Object.assign(acc, metric);
                }
                return acc;
            }, {});

            agent('trackEvent', {
                type: 'customTimings',
                timings
            });
        })
        .catch(e => console.log('custom timing metrics error:', e));
}
